<template>
  <div class="video-thumbnails touch">
    <vue-slick-carousel
      ref="videoSlider"
      v-bind="settings"
      @afterChange="onSliderChange"
    >
      <div v-for="(video, index) in videos" :key="video._id" class="video-card touch">
        <template v-if="getType(video.asset.path) === 'video'">
          <div class="video-card__thumbnail">
            <img :src="$store.state.assetsPath + (video.asset.customPath ? video.asset.customPath : video.asset.thumbPath)">
          </div>
          <div v-if="video.label[language.code]" class="video-card__label">{{ video.label[language.code] }}</div>
          <div
            v-if="status !== 'playing' || index !== activeIndex"
            class="video-card__controls video-card__controls--play touch"
            @click="playVideo(index)"
          >
            <fa :icon="['fas', 'play']"/>
          </div>
          <div
            v-if="index === activeIndex && status === 'playing'"
            class="video-card__controls touch"
            @click="stopVideo"
          >
            <fa :icon="['fas', 'stop']"/>
          </div>
        </template>

        <template v-if="getType(video.asset.path) === 'image'">
          <div class="video-card__thumbnail">
            <img :src="$store.state.assetsPath + (video.asset.customPath ? video.asset.customPath : video.asset.thumbPath)">
          </div>
          <div v-if="video.label[language.code]" class="video-card__label">{{ video.label[language.code] }}</div>
          <div
            v-if="status !== 'playing' || index !== activeIndex"
            class="touch"
          ></div>
          <div
            v-if="index === activeIndex && status === 'playing'"
            class="touch"
          ></div>
        </template>
        
      </div>
      <!-- <template #prevArrow></template>
      <template #nextArrow></template> -->
      <template #customPaging="page">
        <div class="dot">
          {{ page }}
        </div>
      </template>
    </vue-slick-carousel>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  components: { VueSlickCarousel },

  props: ['active-index', 'status', 'videos'],

  data () {
    return {
      settings: {
        "centerMode": true,
        "centerPadding": "0",
        "dots": true,
        "focusOnSelect": true,
        "infinite": true,
        "speed": 500,
        "slidesToShow": 5,
        "slidesToScroll": 1,
        "swipeToSlide": true,
        "touchThreshold": 5
      }
    }
  },

  computed: {
    ...mapGetters([
      'language'
    ]),
  },

  watch: {
    activeIndex () {
      this.$refs.videoSlider.goTo(this.activeIndex)
      this.$emit('play')
    }
  },

  methods: {
    playVideo (index) {
      // only emit play if we hitting play on the currently active slide, in other cases the play will be handled by onSliderChange in the parent
      if (index !== this.activeIndex) return
      this.$emit('play')
    },

    stopVideo () {
      this.$emit('stop')
    },

    onSliderChange (index) {
      this.$emit('index-updated', index)
    },

    getType (source) {
      const ext = source.split('.').pop()

      if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) {
        return 'image'
      }

      if (['mov', 'mp4', 'webm'].includes(ext)) {
        return 'video'
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/_variables.scss";

.video-thumbnails {
  bottom: 6rem;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  width: 85rem;
  z-index: 100;

  &__indicator {
    font-size: 2rem;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    top: -4rem;
  }

  .slick-slide {
    filter: grayscale(100%);
    transform: scale(.85);
    transition: transform 200ms ease-in-out;
  }

  .slick-center {
    filter: grayscale(0);
    transform: scale(1);
  }

  .slick-arrow {
    display: none !important;
  }

  .slick-dots {
    align-items: center;
    bottom: -6rem;
    display: flex !important;
    justify-content: center;
    height: 6rem;
    margin: 0;
    padding: 0;
    position: absolute;
    width: 100%;

    li {
      background: transparent;
      font-size: 0;
      height: 1rem;
      list-style: none;
      margin: 0 .25rem;
      position: relative;
      width: 1rem;

      &.slick-active {
        .dot {
          background: $lime !important;
          border: .1rem solid $lime;
        }
      }

      .dot {
        background: transparent;
        border: .1rem solid rgba($white, .8);
        border-radius: 50%;
        height: 1rem;
        margin: 0;
        width: 1rem;
      }
    }
  }  
}

.video-card {
  border-radius: .5rem;
  box-shadow: .2rem .2rem .2rem rgba(0, 0, 0, .7);
  height: 9.6rem;
  overflow: hidden;
  position: relative;
  width: 100%;

  &__thumbnail {
    background: #000;

    img {
      height: 100%;
      object-fit: cover;
      opacity: .75;
      width: 100%;
    }
  }

  &__label {
    background: rgba(0, 0, 0, .7);
    bottom: 0;
    font-size: .75rem;
    font-weight: 300;
    letter-spacing: .15rem;
    line-height: 1.1;
    padding: .75rem .5rem;
    position: absolute;
    text-align: center;
    text-transform: uppercase;
    width: 100%;
  }

  &__controls {
    align-items: center;
    background: #fff;
    border-radius: 50%;
    display: flex;
    font-size: 1.4rem;
    height: 3rem;
    justify-content: center;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 3rem;

    svg {
      color: #222;
    }

    &--play {
      svg {
        transform: translateX(.1rem);
      }
    }
  }
}
</style>